import React from 'react';
import BangTinhDiem from '../../containers/CauHinhHeThong/BangTinhDiem';

export default function CauHinhHeThong() {
	return <BangTinhDiem />
}